import React, {memo} from 'react';

import Block from '../block';
import IntlStringHtml from '../intl-string-html';
import IntlString, { intlString } from '../intl-string';
import StripedTeaser from '../striped-teaser';
import RatioImage from '../ratio-image';
import { useIntl } from 'react-intl';

const TeaserDark = memo(
	/**
	 * @param {{
	 *   headline: null | undefined | import('../../../tmp/graphql-types').IntlStringFragment,
	 *   text: null | undefined | import('../../../tmp/graphql-types').IntlStringHtmlFragment,
	 *   url: null | undefined | string,
	 *   image: null | undefined | import('../../../tmp/graphql-types').RatioImageFragment,
	 *   hashState: number,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function TeaserDark({
		headline,
		text,
		url,
		image,
		hashState,
	}) {
		const intl = useIntl();

		const anchor = headline && intlString(intl, headline);

		return (
			<Block padding={true} background={true}>
				<StripedTeaser
					hashState={hashState}
					anchor={anchor || undefined}
					headline={headline && (<IntlString handleLines={true} {...headline} />)}
					url={url || undefined}
					left={image && (<RatioImage {...image} />)}
				>
					{text && (
						<IntlStringHtml {...text} />
					)}
				</StripedTeaser>
			</Block>
		);
	}
);

export default TeaserDark;
